import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { ResultadoBusqueda } from '../models/help';

@Injectable({
  providedIn: 'root',
})
export class helpService {
  private httpPublicClient: HttpClient;

  constructor(
    private httpClient: HttpClient,
    private HttpBackend: HttpBackend
  ) {
    this.httpPublicClient = new HttpClient(HttpBackend);
  }

  Buscador(terminoBusqueda: string) {
    return this.httpClient.get(
      encodeURI(`${environment.apiURL}/Help/${terminoBusqueda}/Buscador`)
    );
  }

  BuscadorPublic(terminoBusqueda: string) {
    return this.httpPublicClient.get(
      encodeURI(`${environment.apiURL}/public/${terminoBusqueda}/Buscador`)
    );
  }

  buscarPaginado(pagina: number, cantRegistros: number, text: string) {
    return this.httpClient.get<ResultadoBusqueda>(
      encodeURI(`${environment.apiURL}/Help/${text}/BuscadorPaginado`),
      {
        observe: 'response',
        params: {
          cantidadRegistrosPorPagina: JSON.stringify(cantRegistros),
          pagina: JSON.stringify(pagina),
        },
      }
    );
  }

  buscarPaginadoPublic(pagina: number, cantRegistros: number, text: string) {
    return this.httpPublicClient.get<ResultadoBusqueda>(
      encodeURI(`${environment.apiURL}/public/${text}/BuscadorPaginado`),
      {
        observe: 'response',
        params: {
          cantidadRegistrosPorPagina: JSON.stringify(cantRegistros),
          pagina: JSON.stringify(pagina),
        },
      }
    );
  }

  crearfeedback(feedback: {
    comentario: string;
    esLike: string;
    respuestaId: string;
  }) {
    const formData = new FormData();

    if (feedback.comentario) {
      formData.append('comentarios', feedback.comentario);
    } else {
      formData.append('comentarios', '');
    }
    formData.append('valoracion', feedback.esLike);
    formData.append('respuestaId', feedback.respuestaId);

    return this.httpClient.post(
      encodeURI(`${environment.apiURL}/Help/CreateFeedback`),
      formData
    );
  }

  GuardarSiNo(esLike: string, respuestaId: string) {
    const formData = new FormData();
    formData.append('comentarios', '');
    formData.append('valoracion', esLike);
    formData.append('respuestaId', respuestaId);

    return this.httpClient.post(
      encodeURI(`${environment.apiURL}/Help/GuardarSiNo`),
      formData
    );
  }
}
